// import { Component, OnInit } from '@angular/core';
import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { BoardResponseModel } from "src/app/model/BoardResponseModel";
import { OrganizationResponseModel } from "src/app/model/OrganizationResponseModel";
import { Page } from "src/app/model/Page";
import { MasterService } from "src/app/services/master.service";





@Component({
  selector: 'app-secure-board-list',
  templateUrl: './board-list.component.html',
  styleUrls: ['./board-list.component.scss'],
})
export class BoardListComponent implements OnInit {
  

  page: Page<OrganizationResponseModel>;
  // dataSource: MatTableDataSource<OrganizationResponseModel> = new MatTableDataSource();
  dataSource: MatTableDataSource<BoardResponseModel> = new MatTableDataSource();
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  displayedColumns: string[] = [
    "id",
    "boardLogo",
    "boardCode",
    "boardName",
    "organization",
    "action"
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(public dialog: MatDialog,
    private masterService: MasterService,
    private router: Router,
    private _snackBar: MatSnackBar
    ) {}

  ngOnInit(): void {
    this.loadData(); 
  }

  loadData() {
    this.isLoading = true;
    this.masterService.getBoardList().subscribe((page: any)=>{
      this.isLoading = false;
      console.log(page.content);
      this.page = page;
      this.dataSource = new MatTableDataSource(page.content);
      setTimeout(() => {
        this.paginator.pageIndex = this.currentPage;
        this.paginator.length = page.totalElements;
      });
    });
  }
  
  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }

  editBoard(boardKey: number) {
    console.log("Edit Board called ******** key for board edit"+boardKey);
    this.router.navigate(['/secure', 'master', 'board', 'au', boardKey]);
  }

  deactivate(key: number) {
   if(confirm("Do you want to De-Activate the Board")) {
    console.log("Key for deactivate "+key);
    this.masterService.deactivateBoard(key, 'N').subscribe((data: any)=>{
      if(data.status === 'SUCCESS') {
        let selectedObj = this.page.content.find(o => o.key === key);
        selectedObj.activeFlag = 'N';
      }
      else {
        this.errorToast(data.errorMessage);
      }
    });
   } 
  }

  activate(key: number) {
    if(confirm("Do you want to Activate the Board")) {
      console.log("Key for activate "+key);
      this.masterService.deactivateBoard(key, 'Y').subscribe((data: any)=>{
        if(data.status === 'SUCCESS') {
          let selectedObj = this.page.content.find(o => o.key === key);
          selectedObj.activeFlag = 'Y';
        }
        else {
          this.errorToast(data.errorMessage);
        }
      });
    } 
  }

  async errorToast(errorMessage: string) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
    });
  }

}
